const onEnterPress = (handler) => (e) =>
  handler && e.key === 'Enter' && handler(e);

export default onEnterPress;
